<div class="flex flex-row flex-wrap justify-start items-center">
  <div class="joint-button-container flex flex-row justify-start items-center"
       *ngFor="let companyId of item.cells[fieldDefinition.key]?.value">
    <a class="pointer">{{companyId}}</a>
    <button class="close pointer" (click)="deleteCompanyFromMerge(item.id ,companyId)"
            particleAnalytics
            analyticsCategory="roles-viewer"
            analyticsAction="close-btn">
      <i class="fal fa-times"></i>
    </button>
  </div>
  <button (click)="addCompanyInMerge(item.id)" class="add-user" mat-icon-button
          particleAnalytics
          analyticsCategory="roles-viewer"
          analyticsAction="add">
    <i class="fal fa-plus"></i>
  </button>
</div>
